const Button = ({ label, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="group relative inline-flex h-12 items-center justify-center overflow-hidden rounded-full font-medium cursor-pointer bg-pink-600 shadow-md shadow-pink-900 hover:shadow-blue-900 focus:shadow-blue-900"
    >
      <div className="inline-flex h-12 items-center justify-center px-6 text-white bg-pink-600 rounded-full w-full transition-transform duration-500 group-focus:duration-200 group-hover:-translate-y-full group-focus:-translate-y-full">
        {label}
      </div>

      <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center transition-transform duration-500 group-focus:duration-200  transform translate-y-full group-hover:translate-y-0 group-focus:translate-y-0">
        <span className="absolute top-0 left-0 w-full h-full bg-[#020046] rounded-full"></span>
        <span className="relative z-10 text-white">{label}</span>
      </div>
    </button>
  );
};

export default Button;
